import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import EmployeesVerificationTable from "./employeesVerificationTable";
import { Tabs } from 'antd';
import { employeesVerificationUpdate } from "../../../core/data/redux/employeesVerificationSlice";


interface EmployeesVerificationListProps {
}

const EmployeesVerificationList = (props: EmployeesVerificationListProps) => {

  const user: any = localStorage.getItem("user");
  const userJson = user && user != 'undefined' ? JSON.parse(user) : {};
  const userType: any = userJson?.user_type || userJson?.role;

  const routes = all_routes;
  const location = useLocation();
  const stateFilters = location.state as any;
  const [type, setType] = useState(stateFilters?.status || 'PENDING');
  const onChange = (key: string) => {
    setType(key)
  };
  const employeesVerificationState = useSelector((state: any) => state.employeesVerificationState);

  const tabs: any[] = ['PENDING', 'VERIFIED', 'REJECTED'];
  const dispatch = useDispatch();
  const [docurl, setDocurl] = useState<any>(null);
  const [otherPhotos, setOtherPhotos] = useState<any>([]);
  const [currentItem, setCurrentItem] = useState<any>(null);

  const handleUpdate = async (status: any) => {
    await dispatch(employeesVerificationUpdate({ id: currentItem.id, is_verified: status }));
    setCurrentItem(null);
    //fetchRecords();
  }
  const setItem = async (item: any) => {
    setCurrentItem(item);
  }

  React.useEffect(() => {
    if (employeesVerificationState.loading === "fulfilled" && employeesVerificationState.action === "get") {
      const result = employeesVerificationState?.data?.data || null;
      setDocurl(result.url);
      setOtherPhotos(employeesVerificationState?.data?.data?.attendanceVerification?.employee_verfification_temp_photos || []);
    }

  }, [employeesVerificationState.loading]);


  return (
    <div>
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Face Data Regularize</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Face Data Regularize</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Face Data Regularize
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <Tabs
              activeKey={type}
              onChange={onChange}
              type="card"
              items={tabs.map((item) => {
                return {
                  label: `${item}`,
                  key: item,
                };
              })}
            />
            <EmployeesVerificationTable key={type} type={type} setItem={setItem} />
          </div>
        </div>
      </>

      <div className="modal fade" id="verify-doc" tabIndex={-1} role="dialog" aria-labelledby="assignOfficeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Verify Document/Photo</h4>

              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body" style={{ textAlign: 'center' }}>

              <div className="row">
                <div className="col-md-12">
                  <img src={docurl} width={300} height={300} />
                </div>
                {/* <div className="col-md-12">
                  <div className="row">
                    {(otherPhotos).map((item:any, index:number) => (
                      <div className="col-md-6 mb-3" key={index}>
                        <img src={`data:image/png;base64,${item.photo}`} width={400} height={400} className="img-fluid" />
                      </div>
                    ))}
                  </div>
                </div> */}
              </div>
            </div>

            {(currentItem?.is_verified == 'PENDING' && userType === 'EMPLOYEE') &&
              <div className="modal-footer">
                <Link to="#" data-bs-dismiss="modal" className="btn btn-primary" onClick={() => handleUpdate('VERIFIED')}>
                  Approve
                </Link> &nbsp;&nbsp;
                <Link to="#" data-bs-dismiss="modal" className="btn btn-primary" onClick={() => handleUpdate('REJECTED')}>
                  Reject
                </Link>
              </div>
            }

          </div>
        </div>
      </div>


      <div className="modal fade" id="other-doc" tabIndex={-1} role="dialog" aria-labelledby="assignOfficeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Photos</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body" style={{ textAlign: 'center' }}>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    {(otherPhotos).map((item: any, index: number) => (
                      <div className="col-md-3 mb-3" key={index}>
                        <img src={`data:image/png;base64,${item.photo}`} width={400} height={400} className="img-fluid" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default EmployeesVerificationList; 